import * as style from "./SubjectTag.module.css";

const SubjectTag = ({ subject }) => <div className={style["subject-tag"]}>{subject}</div>;

export default SubjectTag;
